import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function SplitView({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fill={color}
                d="M3.75 15c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06v-9c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h3v1.5h-3v9h3V15h-3Zm4.5 1.5v-15h1.5V3h4.5c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v9c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44h-4.5v1.5h-1.5Zm1.5-3h4.5v-9h-4.5v9Z"
            />
        </svg>
    );
}

export default SplitView;
